import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import injectReducer from '../../../utils/injectReducer';
import injectSaga from '../../../utils/injectSaga';
import * as checkOutActions from '../../FuncComp/actions';
import saga from '../../FuncComp/sagas';
import getCheckOutDetails from '../../FuncComp/reducer';
import * as cartActions from '../../../services/Cart/actions';
import cartSaga from '../../../services/Cart/sagas';
import { getPlansData } from '../../../utils/plansReference';
import mCartDueMonthly from '../../../components/MiniCart/FuncMiniCart/mCartDueMonthly';

const mapStateToProps = (state) => {
  const isCartVisible = state?.cartDetails ? state?.cartDetails?.isCartVisible : {};
  const dueMontAmount = state?.checkout?.lineDetails?.lineInfo?.newLine1?.serviceInfo?.newPricePlanInfo?.planPriceWithDiscount || 0;

  const whwObj = state?.checkout?.lineDetails?.lineInfo?.newLine1?.serviceInfo?.selectedFeaturesList?.visFeature?.filter((obj) =>
    obj?.categoryCodes?.[0]?.toLowerCase()?.includes('whwplus'),
  );

  const dueMontTotalAAL = state?.checkout?.cart?.lineDetails?.lineInfo?.newLine1?.serviceInfo?.totalPriceOfPlanAndPerksWithDiscounts || '0';
  const dueMonthlyList = state?.checkout?.lineDetails?.subAccountNBSInfo
    ? state?.checkout?.lineDetails?.subAccountNBSInfo?.[0]?.billAccounts?.[0]?.nbs?.monthlyChargesInfo
    : '';
  const dueMonthlyProd = state?.checkout?.lineDetails?.lineInfo
    ? state?.checkout?.lineDetails?.lineInfo?.newLine1?.serviceInfo?.newPricePlanInfo
    : '';
  // const dueMonHomePhone = state?.checkout?.lineDetails?.lineInfo
  //   ? state?.checkout?.lineDetails?.lineInfo?.newLine2?.serviceInfo?.newPricePlanInfo
  //   : '';
  const dueMonthlyTaxes = state?.checkout?.orderDetails?.totalMonthlyTaxes || 0;
  const plansReferenceData = getPlansData(state.plansReferenceData);
  const npaNXXVal = state?.checkout?.lineDetails?.lineInfo?.newLine2?.mtnDetails?.npaNXX || '';
  const depletionType = state.checkout?.depletionType || '';
  const planPerks = state?.checkout?.lineDetails?.lineInfo?.newLine1?.serviceInfo?.planPerks || [];

  return {
    isCartVisible,
    dueMonthlyList,
    dueMonthlyTaxes,
    dueMontAmount,
    plansReferenceData,
    dueMonthlyProd,
    whwObj,
    // dueMonHomePhone,
    npaNXXVal,
    depletionType,
    planPerks,
    dueMontTotalAAL,
  };
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ ...checkOutActions, ...cartActions }, dispatch);
}

const withReducer = compose(injectReducer({ key: 'checkout', reducer: getCheckOutDetails }));

const withConnect = connect(mapStateToProps, mapDispatchToProps);

// const withSaga = injectSaga({ key: 'checkoutDetails', saga });
// injectSaga({ key: 'cartDetails', cartSaga });
// TODO: Need to check if we can combine both sagas
const withSaga = compose(injectSaga({ key: 'checkoutDetails', saga }), injectSaga({ key: 'cartDetails', saga: cartSaga }));

export default withRouter(compose(withSaga, withReducer, withConnect)(mCartDueMonthly));
